module.exports = __webpack_public_path__ + "static/media/poc-user-type-active.9500a164.svg";